module.exports = __webpack_public_path__ + "img/photo-11.b6880c3f.webp";